"use client";

import { HmcChip, HmcIcon } from "@adi-ctx/harmonic-core-components-react";
import { t } from "@/utils";
import { RiFilterOffLine } from "@remixicon/react";
import type { TFilters } from "@/types";

type FilterAppliedProps = {
	readonly filters: TFilters;
	readonly onClearFilter: (filters: string[]) => void;
};

/**
 * Display a list of applied filters and the possibility to clear them
 * @constructor
 */
export default function FilterApplied(props: FilterAppliedProps) {
	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{Boolean(props.filters.subsystem?.length) && (
				<section className="mb-6 flex items-start justify-between gap-3 bg-layoutContainer">
					<div className="flex flex-wrap items-center gap-2 bg-layoutContainer">
						{props.filters.subsystem?.map((subsystem: string) => (
							<HmcChip
								key={subsystem}
								hasCheckmark={false}
								title={t("filters.clear-filter")}
								size="sm"
								data-testid="filter-applied"
								onClick={() => {
									props.onClearFilter([subsystem]);
								}}
							>
								<span
									className="hmc-button-s flex items-center gap-1 font-semibold text-systemInfo"
									data-testid="filter-applied-remove"
								>
									{subsystem}
									<HmcIcon
										className="w-[18px]"
										name="close-m"
										data-testid="filter-applied-remove-icon"
									/>
								</span>
							</HmcChip>
						))}
					</div>

					<span
						className="hmc-button-s flex items-center gap-1 whitespace-nowrap font-semibold text-systemInfo hover:cursor-pointer hover:underline"
						data-testid="filter-applied-remove-all"
						onClick={() => {
							props.onClearFilter([...props.filters.subsystem]);
						}}
					>
						<RiFilterOffLine
							size={16}
							data-testid="filter-applied-remove-all-icon"
						/>
						{t("filters.clear-filters")}
					</span>
				</section>
			)}
		</>
	);
}
